module.exports = __webpack_public_path__ + "static/media/earingCardIcon.cceaba4d.svg";